var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackTwoVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.475981 10.3401C-0.15866 10.9816 -0.15866 12.0235 0.475981 12.665L10.2241 22.5189C10.8587 23.1604 11.8894 23.1604 12.524 22.5189C13.1587 21.8773 13.1587 20.8355 12.524 20.194L3.92335 11.5L12.5189 2.80604C13.1536 2.16451 13.1536 1.12267 12.5189 0.481145C11.8843 -0.160382 10.8536 -0.160382 10.219 0.481145L0.470904 10.335L0.475981 10.3401Z",
    fill: "url(#paint0_linear_3569_23813)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.476 10.3401C10.8413 10.9816 10.8413 12.0235 11.476 12.665L21.2241 22.5189C21.8587 23.1604 22.8894 23.1604 23.524 22.5189C24.1587 21.8773 24.1587 20.8355 23.524 20.194L14.9234 11.5L23.5189 2.80604C24.1536 2.16451 24.1536 1.12267 23.5189 0.481145C22.8843 -0.160382 21.8536 -0.160382 21.219 0.481145L11.4709 10.335L11.476 10.3401Z",
    fill: "url(#paint1_linear_3569_23813)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3569_23813",
    x1: 13,
    y1: 0,
    x2: -0.337264,
    y2: 0.197265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3569_23813",
    x1: 24,
    y1: 0,
    x2: 10.6627,
    y2: 0.197265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTwoVector);
export default __webpack_public_path__ + "static/media/back-two-vector.193987c139bc714c8fb1f699a29ea580.svg";
export { ForwardRef as ReactComponent };